<div class="login-page">
    <div class="well container">
        <div class="well-title">
            <div class="col-md-12">Reset password</div>
        </div>
        <div class="col-md-8 well-content">
            @if (!submitted) {
                <form class="form-horizontal" role="form" [formGroup]="form" (ngSubmit)="onSubmit()">
                    <h4>Reset your password.</h4>
                    <hr />
                    @if (errorMessage) {
                        <div class="alert alert-danger">{{ errorMessage }}</div>
                    }
                    <div class="form-group">
                        <label class="col-md-2 control-label" for="email">Email</label>
                        <div class="col-md-10">
                            <input
                                id="email"
                                type="text"
                                class="form-control"
                                formControlName="email"
                                autocomplete="username" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label" for="password">Password</label>
                        <div class="col-md-10">
                            <input
                                id="password"
                                type="password"
                                class="form-control"
                                formControlName="password"
                                autocomplete="new-password"
                                placeholder="New Password" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label" for="confirmPassword">Confirm password</label>
                        <div class="col-md-10">
                            <input
                                id="confirmPassword"
                                type="password"
                                class="form-control"
                                formControlName="confirmPassword"
                                autocomplete="new-password"
                                placeholder="Confirm New Password" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-offset-2 col-md-10">
                            <button type="submit" class="btn btn-default" [disabled]="submitting">
                                {{ submitting ? "Resetting..." : "Reset" }}
                            </button>
                        </div>
                    </div>
                </form>
            }

            @if (submitted) {
                <p>Your password has been reset. Please <a routerLink="/account/login">click here to log in</a>.</p>
            }
        </div>
    </div>
</div>
